import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { ShieldCheckIcon } from 'lucide-react';
export function ProductRevealSection() {
  return <section className="py-12" data-id="element-280">
      <div className="max-w-2xl mx-auto editorial-text" data-id="element-281">
        <FadeIn data-id="element-282">
          <p className="font-[700]" data-id="element-283">
            Together these five ingredients create something that has never
            existed in a single formula before.
          </p>
          <p data-id="element-284">
            And until now — the only way to get it was sitting in my chair here
            in Los Angeles.
          </p>
          <p data-id="element-285">
            But today, for the first time ever, I'm making the most advanced
            version of this formula available to anyone who needs it.
          </p>

          <div className="text-center my-16" data-id="element-286">
            <h2 className="text-4xl font-sans font-black text-gray-900 mb-4 tracking-tight" data-id="element-287">
              Introducing ClearGuard Pro
            </h2>
            <div className="w-24 h-1 bg-teal-500 mx-auto rounded-full" data-id="element-288"></div>
          </div>

          <div className="rounded-xl overflow-hidden mb-6" data-id="element-289">
            <img src="https://cdn.magicpatterns.com/uploads/cHwiDgCdJQbCo2fSqw3cWd/hf_20260403_071555_a3e26d5b-13ca-460e-b7f6-ce7bb9391aa2_(1).png" alt="ClearGuard Pro Biofilm Defense product bottles with probiotic tablets and natural ingredients" className="w-full h-auto object-cover" data-id="element-290" />
          </div>

          <p data-id="element-291">
            Just imagine never running your tongue across your teeth
            self-consciously before a conversation…
          </p>
          <p data-id="element-292">
            Never again dreading that next dentist appointment — wondering what
            bad news is waiting for you this time…
          </p>
          <p data-id="element-293">
            And what were once bleeding, swollen gums that ruined your morning
            routine suddenly feel firm, healthy, and pain-free…
          </p>
          <p data-id="element-294">
            With teeth so smooth and clean, you notice it yourself before your
            dentist even says a word…
          </p>
          <p className="font-[700]" data-id="element-295">
            And with every week you take ClearGuard Pro, the biofilm fortress
            that's been building for years begins to dissolve — and the
            foundation underneath starts coming back stronger.
          </p>
          <p data-id="element-296">
            What's more, breathing freely through your nose at night, waking up
            without that stale, metallic taste in your mouth…
          </p>
          <p data-id="element-297">
            And no longer covering your mouth when you laugh or turning away
            when someone gets close…
          </p>
          <p data-id="element-298">
            I'm even willing to bet your dentist asks what you've been doing
            differently — because they'll see the difference before you even
            have to mention it.
          </p>
          <p data-id="element-299">That's just how effective ClearGuard Pro is.</p>
          <p data-id="element-300">
            If any of this sounds like the future you want to wake up to — the
            time to act is now.
          </p>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-301">
          <div className="my-12 py-8 border-t border-b border-gray-200" data-id="element-302">
            <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-303">
              But you may be wondering - how much does ClearGuard Pro cost?
            </h2>
            <div className="rounded-xl overflow-hidden mb-6" data-id="element-304">
              <img src="https://cdn.magicpatterns.com/uploads/rR1jTtKzpGVQs9jbaoj3YA/hf_20260403_075259_e9248a7d-5e6d-4d3f-80e0-c7322d0bf697_(1).png" alt="Customer testimonial from Linda about her experience with ClearGuard Pro" className="w-full h-auto object-cover" data-id="element-305" />
            </div>
            <p data-id="element-306">
              Well, as you can imagine, sourcing naturally-derived
              microcrystalline hydroxyapatite from the pastures of New Zealand
              and Australia isn't simple.
            </p>
            <p className="font-[700]" data-id="element-307">
              These aren't generic ingredients you can order in bulk from a
              warehouse.
            </p>
            <p data-id="element-308">
              The cattle have to be pasture-raised. The mineral has to be
              extracted and processed to exact specifications.
            </p>
            <p data-id="element-309">
              Not to mention, the particle size has to be precise — too small
              and it crosses into the bloodstream, too large and it won't bond
              to enamel properly.
            </p>
            <p className="font-[700]" data-id="element-310">
              Then there are the three probiotic strains.
            </p>
            <p data-id="element-311">
              Finding the right strains is one thing. Getting them in
              therapeutic doses is another.
            </p>
            <p data-id="element-312">But the real challenge? Keeping them alive.</p>
            <p data-id="element-313">
              See, what I learned is that most probiotic manufacturers use
              processing methods that kill the bacteria before the bottle even
              reaches your door…
            </p>
            <p data-id="element-314">
              Meaning you're swallowing dead cultures that do absolutely
              nothing.
            </p>
            <p data-id="element-315">
              I refused to compromise on that — which meant finding one of only
              a handful of facilities in the country capable of doing this
              correctly.
            </p>
            <p className="font-[700]" data-id="element-316">
              And the price of our first batch? It cost us a whopping $47,000 to
              produce…
            </p>
            <p data-id="element-317">
              Quite frankly, that cost still makes our accountant uncomfortable.
            </p>
            <p data-id="element-318">
              But here's the decision I made — one that my accountant and my
              lawyer both strongly advised against.
            </p>
            <p data-id="element-319">
              Since it's our official online launch, I ordered a special
              shipment.
            </p>
            <p className="font-[700]" data-id="element-320">
              And instead of pricing ClearGuard Pro at what the "marketing
              experts" recommended…
            </p>
            <p data-id="element-321">
              I priced it at what would actually get it into the hands of people
              who need it most.
            </p>
            <p data-id="element-322">
              Why? Because at the end of the day, a patient walking out of my
              office feeling better will always matter more to me than the
              money.
            </p>
            <p data-id="element-323">And that applies to you as well.</p>
            <p data-id="element-324">
              Which means today, on this page only, you won't pay anywhere near
              what this formula is worth.
            </p>
            <p className="font-[700]" data-id="element-325">
              In fact, for a full 3-month supply - which is what I recommend to
              my patients for proper restoration - you're not paying even close
              to what a deep cleaning would normally cost.
            </p>
            <p data-id="element-326">Not $1,500. Not $1,000. Not $500. Not even $250.</p>
            <p data-id="element-327">
              Instead, your complete 90-day supply of ClearGuard Pro — with all
              six ingredients, formulated to the exact specifications I use with
              my own patients — is just $197.
            </p>
            <p className="font-[700]" data-id="element-328">
              That's right. Three full months of complete oral restoration for
              just $2 a day.
            </p>
            <p data-id="element-329">Less than the cost of a single cleaning.</p>
            <p data-id="element-330">Less than two months of whitening strips.</p>
            <p data-id="element-331">
              Less than what most people spend on mouthwash and toothpaste in a
              year.
            </p>
            <p data-id="element-332">
              For a dentist-formulated formula backed by over 60 clinical
              studies, sourced from the finest pastures in New Zealand and
              Australia, manufactured in an FDA-registered facility right here
              in the United States.
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-333">
          <p className="font-[700]" data-id="element-334">
            But that's not all. Because I've seen firsthand what happens when
            patients run out after 90 days…
          </p>

          <div className="rounded-xl overflow-hidden mb-6" data-id="element-335">
            <img src="https://cdn.magicpatterns.com/uploads/uREf6eixS97MoVBhsqt9xC/hf_20260403_081649_f90f917b-8700-4bda-ae4f-adfa449c7e75_(2).png" alt="Patient text message to Dr. Chen urgently requesting more chews" className="w-full h-auto object-cover" data-id="element-336" />
          </div>
          <p data-id="element-337">They call my office in a panic.</p>
          <p data-id="element-338">
            Not because something went wrong — but because something went very
            right.
          </p>
          <p data-id="element-339">
            They can feel the difference. Their gums aren't bleeding anymore.
          </p>
          <p data-id="element-340">
            Their breath is clean. They're leaving the dentist with good news
            for the first time in years.
          </p>
          <p data-id="element-341">
            And the thought of going back to where they were terrifies them.
          </p>
          <p className="font-[700]" data-id="element-342">
            In fact, the results are so real that I've had patients drive across
            town to my office just to ask if they can get more.
          </p>
          <p data-id="element-343">
            That's when I realized I won't let supply be the reason someone
            loses the progress they worked three months to build.
          </p>
          <p data-id="element-344">
            So I decided to do something my accountant is still not happy about…
          </p>
          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-6" data-id="element-345">
            On this page only, when you order a 90-day supply today, I'm
            doubling it, for free.
          </h2>

          <div className="rounded-xl overflow-hidden mb-6" data-id="element-346">
            <img src="https://cdn.magicpatterns.com/uploads/9h7FB6KfPyPfxLA1qTDuCD/hf_20260403_083205_20299549-10a3-4378-b0bc-0c636efcd37b_(1).png" alt="ClearGuard Pro buy 3 get 3 bottles free offer" className="w-full h-auto object-cover" data-id="element-347" />
          </div>

          <p data-id="element-348">That's right. Three full months, completely for free.</p>
          <p data-id="element-349">
            Because here's the truth — most people who try ClearGuard Pro don't
            want to stop at 90 days.
          </p>
          <p data-id="element-350">
            They want to keep going - and I don't want supply to be the reason
            they can't.
          </p>
          <p data-id="element-351">
            So today only, you get everything you need to see this through
            completely.
          </p>
          <p data-id="element-352">
            Three months to restore. Three months free to protect what you've
            rebuilt.
          </p>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-353">
          <div className="my-12 py-8 border-t border-b border-gray-200" data-id="element-354">
            <p className="font-[700]" data-id="element-355">
              But there's one other thing I need you to understand.
            </p>
            <p data-id="element-356">
              This special shipment ordered for this launch is extremely
              limited.
            </p>
            <p data-id="element-357">
              The same supply chain challenges that make this formula expensive
              to produce also make it unpredictable to restock.
            </p>
            <p data-id="element-358">
              Meaning I can't guarantee this page will be here the next time you
              look for it — because we may not have inventory available.
            </p>
            <p data-id="element-359">
              And since waiting means you might risk missing out entirely, you
              won't be risking a single dollar today…
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-360">
          <div className="bg-blue-50 rounded-2xl p-8 border border-blue-100 my-12 text-center" data-id="element-361">
            <ShieldCheckIcon className="w-16 h-16 text-blue-600 mx-auto mb-4" data-id="element-362" />
            <h3 className="text-2xl font-sans font-bold text-gray-900 mb-4" data-id="element-363">
              In fact, you have 90 days to try ClearGuard Pro risk-free.
            </h3>
            <div className="text-gray-800 space-y-4 text-left" data-id="element-364">
              <p data-id="element-365">
                That's right. Because how are you supposed to know if something
                truly works in 30, or even 60 days?
              </p>
              <p data-id="element-366">See, ClearGuard Pro takes time to work….</p>
              <p data-id="element-367">
                Biofilm didn't build overnight, and the oral microbiome won't be
                fully restored in a week.
              </p>
              <p data-id="element-368">
                However, this doesn't mean you won't feel anything in the first
                few days.
              </p>
              <p data-id="element-369">
                In fact, many of my patients report feeling cleaner - just as
                soon as the first chew dissolves in their mouth.
              </p>
              <p data-id="element-370">But the real restoration takes time.</p>
              <p data-id="element-371">
                Which is exactly why I'm giving you a full 90 days - three full
                months - to try it for yourself completely risk-free.
              </p>
              <p data-id="element-372">
                If at any point in those 90 days you're not seeing the results
                you expected, just reach out to my support team and you'll get
                every single penny back.
              </p>
              <p data-id="element-373">No questions. No hassle. No hoops to jump through.</p>
              <p data-id="element-374">Plus, the three free bottles are yours to keep regardless.</p>
              <p data-id="element-375">
                Yes, I'm that confident. Because I've seen what this formula
                does in my own practice.
              </p>
            </div>
            <div className="mt-8 text-center" data-id="element-376">
              <a href="https://www.tryclearguard.com/storefront" target="_blank" rel="noopener noreferrer" className="inline-block w-full md:w-auto bg-teal-600 hover:bg-teal-700 text-white font-sans font-bold text-xl py-5 px-10 rounded-full shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1 text-center" data-id="element-377">
                Try ClearGuard Pro Risk-Free Today
              </a>
              <p className="font-sans text-sm text-gray-500 mt-4 font-semibold" data-id="element-378">
                Get 6 Months For The Price of 3 • 90-Day Money Back Guarantee
              </p>
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-379">
          <p data-id="element-380">
            So what I can promise is this — the 90 days means you risk nothing
            by acting today.
          </p>
          <p className="font-semibold" data-id="element-381">
            But walking away means risking something far more expensive than the
            price of this formula:
          </p>
          <p data-id="element-382">
            Months more of the same bleeding, the same cavities, the same bad
            news at the dentist — while biofilm continues doing damage that gets
            harder to reverse with every passing day.
          </p>
          <p data-id="element-383">Which finally brings me to my last point today…</p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-384">
          <div className="my-12" data-id="element-385">
            <h3 className="text-2xl md:text-3xl font-sans font-bold mb-6 text-gray-900" data-id="element-386">
              Do You Consider Yourself a Part of The 97%, Or The 3%?
            </h3>
            <p data-id="element-387">
              Here's something I tell my patients when they're sitting in my
              chair weighing a decision.
            </p>
            <p data-id="element-388">
              97% of people who learn about the Biofilm Crisis today will do
              nothing.
            </p>
            <p data-id="element-389">
              Not because they don't want healthier teeth. Not because they
              don't believe the science.
            </p>
            <p data-id="element-390">
              But because somewhere between understanding the problem and making
              the decision — doubt creeps in.
            </p>
            <p className="italic text-gray-500" data-id="element-391">
              'Let me think about it.' 'Maybe later.' 'I'll try one more thing
              first.'
            </p>
            <p data-id="element-392">
              The result? Six months from now they're back in that same chair
              hearing the same bad news…
            </p>
            <p data-id="element-393">Still needing procedures they could have avoided entirely.</p>
            <p data-id="element-394">A $4,000 implant. A gum graft. Extractions. Deep cleanings.</p>
            <p data-id="element-395">At least, that's how it goes for most people…</p>
            <p data-id="element-396">
              Because on the other hand, 3% of people make a different decision.
            </p>
            <p data-id="element-397">
              Not because they have less fear or less doubt. In fact, they have
              exactly the same fears as the 97%.
            </p>
            <p data-id="element-398">
              Instead, they just decide that the life they want matters more
              than the discomfort of trying something new.
            </p>
            <p data-id="element-399">
              Those are the people who call my office three months later and say
              'I can't believe I waited as long as I did.'
            </p>
            <p data-id="element-400">I don't know which one you are…</p>
            <p data-id="element-401">
              But I have a feeling — if you've read this far — you already know.
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-402">
          <div className="mt-12 text-center" data-id="element-403">
            <a href="https://www.tryclearguard.com/storefront" target="_blank" rel="noopener noreferrer" className="inline-block w-full md:w-auto bg-teal-600 hover:bg-teal-700 text-white font-sans font-bold text-xl py-5 px-10 rounded-full shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1 text-center" data-id="element-404">
              Try ClearGuard Pro Risk-Free Today
            </a>
            <p className="font-sans text-sm text-gray-500 mt-4 font-semibold" data-id="element-405">
              Get 6 Months For The Price of 3 • 90-Day Money Back Guarantee
            </p>
          </div>

          <div className="mt-16 pt-8 border-t border-gray-200" data-id="element-406">
            <p className="text-xs text-gray-400 font-semibold uppercase tracking-wider mb-3 text-center" data-id="element-407">
              Scientific References
            </p>
            <ul className="text-xs text-gray-400 space-y-1 list-none text-center" data-id="element-408">
              <li data-id="element-409">pmc.ncbi.nlm.nih.gov/articles/PMC9955010/</li>
              <li data-id="element-410">clinicaltrials.gov/study/NCT02444182</li>
              <li data-id="element-411">pmc.ncbi.nlm.nih.gov/articles/PMC9131035/</li>
              <li data-id="element-412">pmc.ncbi.nlm.nih.gov/articles/PMC4232036/</li>
              <li data-id="element-413">pmc.ncbi.nlm.nih.gov/articles/PMC12466288/</li>
              <li data-id="element-414">pmc.ncbi.nlm.nih.gov/articles/PMC6926775/</li>
              <li data-id="element-415">pmc.ncbi.nlm.nih.gov/articles/PMC4127827/</li>
              <li data-id="element-416">pmc.ncbi.nlm.nih.gov/articles/PMC12705589/</li>
              <li data-id="element-417">pmc.ncbi.nlm.nih.gov/articles/PMC9668099/</li>
              <li data-id="element-418">pmc.ncbi.nlm.nih.gov/articles/PMC10187049/</li>
              <li data-id="element-419">pmc.ncbi.nlm.nih.gov/articles/PMC10421449/</li>
              <li data-id="element-420">pmc.ncbi.nlm.nih.gov/articles/PMC5851198/</li>
              <li data-id="element-421">pmc.ncbi.nlm.nih.gov/articles/PMC5824418/</li>
            </ul>
          </div>
        </FadeIn>
      </div>
    </section>;
}